export const I18N = {
  defaultLanguage: 'en',
  storageKey: 'wigum-language',
  languages: [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'no', label: 'Norsk', flag: '🇳🇴' },
  ],
  strings: {
    en: {
      aboutFallbackTitle: 'About Us.',
      aboutTeamPrompt: 'Want to learn about the team?',
      aboutUs: 'About Us',
      allDevelopmentUpdates: 'All development updates',
      backToHomepage: 'Back to homepage',
      blogCouldNotLoadPosts: 'Blog: Could not load posts',
      blogNoBlogFound: 'Blog: No blog found',
      collapse: 'Collapse',
      companyFocus: 'Company focus',
      companyFocusBody: 'We focus on optimized low-poly games that can run on most devices, ship cross-platform, and support flexible control options like phones acting as gamepads over Wi-Fi or Bluetooth. Our game loops are designed to scale exponentially so casual players can start comfortably while skilled players always have harder challenges to master.',
      couldNotLoadGames: 'Could not load games.',
      couldNotLoadRoadmap: 'Could not load roadmap.',
      couldNotLoadUpdates: 'Could not load updates.',
      currentProjects: 'Current projects.',
      developmentBlog: 'Development blog',
      download: 'Download',
      failedAboutPageText: 'Failed to fetch about-us page text.',
      failedGameDescription: 'Failed to fetch game description.',
      failedGamePreviewImage: 'Failed to fetch game preview image.',
      failedMemberImage: 'Failed to fetch member image.',
      failedMemberName: 'Failed to fetch member name.',
      failedMemberText: 'Failed to fetch member text.',
      failedTeamMembers: 'Failed to fetch team members.',
      fetchingAboutContent: 'Fetching about-us content from blog git repo...',
      fetchingBlogContent: 'Fetching content from blog git repo...',
      fetchingGameFolder: 'Fetching the game folder from the blog git repo...',
      fetchingGames: 'Fetching games from blog git repo...',
      fetchingRoadmap: 'Fetching roadmap from blog git repo...',
      fetchingTeamMembers: 'Fetching team members from blog git repo...',
      gameFolderUnavailable: 'The game folder list is unavailable right now.',
      gameNotFound: 'Game not found.',
      gamePageDoesNotExist: 'This page does not exist yet.',
      games: 'Games',
      gamesList: 'Games list',
      gamesOverviewLead: 'Games are grouped by shipped releases, active development, and ideas we may build later.',
      githubRepositoryLabel: 'GitHub repository',
      home: 'Home',
      homeGamesCard: 'Browse the current game projects and follow each dedicated project page.',
      homeControlsBody: 'We design for cross-platform play with flexible input paths, including the option to connect phones as gamepads over Wi-Fi or Bluetooth when a project supports it.',
      homeControlsImageAlt: 'TV connected to three landscape phones as controllers placeholder',
      homeControlsLabel: 'Flexible input',
      homeControlsTitle: 'Flexible controls across devices.',
      homeDesignBody: 'Our game algorithms prioritize exponential difficulty curves. Rookies should get mastery moments early, while the best players still meet real challenge later as the loop keeps escalating.',
      homeDesignImageAlt: 'Exponential difficulty curve placeholder',
      homeDesignLabel: 'Difficulty curve',
      homeDesignTitle: 'Exponential difficulty curves.',
      homepageSections: 'Homepage sections',
      homeLead: 'An independent studio building optimized low-poly 3D and sprite-based 2D games around accessible shared play.',
      homeLowPolyBody: 'Low-poly 3D and sprite-based 2D let us keep games readable, fast, and portable so they can run on as many devices as possible without losing a clear visual direction.',
      homeLowPolyImageAlt: 'Low-poly and sprite-based game art placeholder',
      homeLowPolyLabel: 'Performance first',
      homeLowPolyTitle: 'Optimized 3D and 2D that run broadly.',
      homeTitle: 'Cross-platform games built to scale.',
      homeToolsCard: 'Open practical production references and workflow helpers.',
      homeTeamplayBody: 'Our philosophy is to reward playing together. Local co-op and multiplayer should not scale 1:1 harder just because more players join, so teaming up feels encouraged while solo play remains doable.',
      homeTeamplayImageAlt: 'Players joining together without a steep difficulty spike placeholder',
      homeTeamplayLabel: 'Co-op philosophy',
      homeTeamplayTitle: 'Teamplay should feel rewarded.',
      homeUpdatesCard: 'Read the latest progress notes across all active projects.',
      languageSelector: 'Language selector',
      linuxCommand: 'Linux command',
      loadingGame: 'Loading game.',
      loadingGames: 'Loading games...',
      noGamesFound: 'No games found.',
      noFinishedGamesFound: 'No finished games yet.',
      noPlannedGamesFound: 'No planned game ideas listed yet.',
      noRoadmapStepsFound: 'No roadmap steps found.',
      noRoadmapTextFound: 'No roadmap text found.',
      noUpdatesFound: 'No updates found.',
      noUpcomingGamesFound: 'No upcoming games found.',
      finishedGames: 'Finished games',
      moreAboutUsPrompt: 'More about us',
      plannedGameIdeas: 'Game ideas',
      preview: 'Preview',
      productionTools: 'Production tools',
      readPost: 'Read post',
      roadmap: 'Roadmap',
      sheetBlenderAlt: 'Blender keyboard shortcut reference sheet',
      sheetBlenderCaption: 'SVG Blender modeling and navigation shortcut sheet.',
      sitePages: 'Site pages',
      steamDownload: 'Steam page',
      switchLanguageTo: 'Switch language to',
      team: 'Team',
      tools: 'Tools',
      toolsInstallLead: 'Linux users can copy the command for the tool they need. Windows users can use the download links. The .NET SDK is included because the Godot projects use C#.',
      toolsLead: 'Small production helpers and reference sheets we use while building games.',
      toolsTitle: 'Production tools.',
      toggleNavigationMenu: 'Toggle navigation menu',
      untitledRoadmapItem: 'Untitled roadmap item.',
      updates: 'Updates',
      updatesLead: 'All project posts in one place, sorted by newest update first.',
      upcomingGames: 'Upcoming games',
      viewGamePage: 'View game page',
      visitAseprite: 'Visit Aseprite',
      visitBlender: 'Visit Blender',
      visitDotnet: 'Visit .NET',
      visitGit: 'Visit Git',
      visitGithub: 'Visit GitHub',
      visitGithubCli: 'Visit GitHub CLI',
      visitGodot: 'Visit Godot',
      visitInkscape: 'Visit Inkscape',
      visitRoblox: 'Visit Roblox Creator Hub',
      visitVscode: 'Visit VS Code',
      workflow: 'Workflow',
      workflowAsepriteBody: 'Aseprite is used for 2D pixel art, small sprite work, and pixel-focused game visuals when a project needs that style.',
      workflowBlenderBody: 'Graphics and low-poly assets are modeled in Blender so art direction, optimization, and export flow stay lightweight and practical for cross-platform games.',
      workflowDotnetBody: 'The .NET SDK supports the C# side of our Godot projects, including scripting, builds, and local development tooling.',
      workflowGitBody: 'Git handles local version control so experiments, fixes, and feature branches can be tracked safely before they are shared.',
      workflowGithubCliBody: 'GitHub CLI keeps repository work fast from the terminal, including authentication, issues, pull requests, and project checks.',
      workflowGithubBody: 'All development is version-controlled and publicly documented through GitHub. You can follow updates, source code, and progress logs across multiple projects, from experimental systems to playable demos.',
      workflowGodotBody: 'Focused on cross-platform 2D and 3D game development using C#. Godot is now our main engine, chosen for its open-source flexibility, lightweight performance, modular workflow, and strong Linux support.',
      workflowInkscapeBody: 'Inkscape is used for icons, vector graphics, and lightweight UI art before assets move into the game or website pipeline.',
      workflowRobloxBody: 'Roblox is part of the content direction we may build for, using Roblox Studio for platform-specific experiences and experiments.',
      workflowVscodeBody: 'VS Code is the primary code editor for C#, web, scripting, notes, and quick project work across the toolchain.',
      windowsDownload: 'Windows download',
    },
    no: {
      aboutFallbackTitle: 'Om Oss.',
      aboutTeamPrompt: 'Vil du lese om teamet?',
      aboutUs: 'Om Oss',
      allDevelopmentUpdates: 'Alle utviklingsoppdateringer',
      backToHomepage: 'Tilbake til forsiden',
      blogCouldNotLoadPosts: 'Blogg: Kunne ikke laste innlegg',
      blogNoBlogFound: 'Blogg: Ingen blogg funnet',
      collapse: 'Lukk',
      companyFocus: 'Selskapsfokus',
      companyFocusBody: 'Vi fokuserer på optimaliserte lavpoly-spill som kan kjøre på flest mulig enheter, gis ut på tvers av plattformer, og støtte fleksible kontrollvalg som mobiler brukt som gamepad over Wi-Fi eller Bluetooth. Spill-loopene våre er laget for å skalere eksponentielt, slik at nye spillere kan starte trygt mens erfarne spillere alltid får vanskeligere utfordringer å mestre.',
      couldNotLoadGames: 'Kunne ikke laste spill.',
      couldNotLoadRoadmap: 'Kunne ikke laste veikart.',
      couldNotLoadUpdates: 'Kunne ikke laste oppdateringer.',
      currentProjects: 'Nåværende prosjekter.',
      developmentBlog: 'Utviklingsblogg',
      download: 'Last ned',
      failedAboutPageText: 'Kunne ikke hente tekst for om oss-siden.',
      failedGameDescription: 'Kunne ikke hente spillbeskrivelse.',
      failedGamePreviewImage: 'Kunne ikke hente forhåndsvisningsbilde.',
      failedMemberImage: 'Kunne ikke hente medlemsbilde.',
      failedMemberName: 'Kunne ikke hente medlemsnavn.',
      failedMemberText: 'Kunne ikke hente medlemstekst.',
      failedTeamMembers: 'Kunne ikke hente teammedlemmer.',
      fetchingAboutContent: 'Henter om oss-innhold fra blogg-repo...',
      fetchingBlogContent: 'Henter innhold fra blogg-repo...',
      fetchingGameFolder: 'Henter spillmappen fra blogg-repo...',
      fetchingGames: 'Henter spill fra blogg-repo...',
      fetchingRoadmap: 'Henter veikart fra blogg-repo...',
      fetchingTeamMembers: 'Henter teammedlemmer fra blogg-repo...',
      gameFolderUnavailable: 'Listen over spillmapper er ikke tilgjengelig akkurat nå.',
      gameNotFound: 'Spill ikke funnet.',
      gamePageDoesNotExist: 'Denne siden finnes ikke ennå.',
      games: 'Spill',
      gamesList: 'Spilliste',
      gamesOverviewLead: 'Spill er gruppert etter ferdige utgivelser, aktiv utvikling og ideer vi kanskje bygger senere.',
      githubRepositoryLabel: 'GitHub-repositorium',
      home: 'Hjem',
      homeGamesCard: 'Se de nåværende spillprosjektene og følg hver egen prosjektside.',
      homeControlsBody: 'Vi designer for spilling på tvers av plattformer med fleksible kontrollvalg, inkludert muligheten til å koble mobiler som gamepads over Wi-Fi eller Bluetooth når prosjektet støtter det.',
      homeControlsImageAlt: 'Placeholder for TV koblet til tre liggende mobiler som kontrollere',
      homeControlsLabel: 'Fleksibel input',
      homeControlsTitle: 'Fleksible kontroller på tvers av enheter.',
      homeDesignBody: 'Spillalgoritmene våre prioriterer eksponentielle vanskelighetskurver. Nybegynnere skal få mestringsfølelse tidlig, mens de beste spillerne fortsatt møter ekte utfordring senere når loopen fortsetter å eskalere.',
      homeDesignImageAlt: 'Placeholder for eksponentiell vanskelighetskurve',
      homeDesignLabel: 'Vanskelighetskurve',
      homeDesignTitle: 'Eksponentielle vanskelighetskurver.',
      homepageSections: 'Forsideseksjoner',
      homeLead: 'Et uavhengig studio som lager optimaliserte lavpoly 3D- og sprite-baserte 2D-spill rundt tilgjengelig felles spilling.',
      homeLowPolyBody: 'Lavpoly 3D og sprite-basert 2D lar oss holde spill lesbare, raske og portable slik at de kan kjøre på flest mulig enheter uten å miste en tydelig visuell retning.',
      homeLowPolyImageAlt: 'Placeholder for lavpoly og sprite-basert spillgrafikk',
      homeLowPolyLabel: 'Ytelse først',
      homeLowPolyTitle: 'Optimalisert 3D og 2D som kjører bredt.',
      homeTitle: 'Plattformuavhengige spill bygget for å skalere.',
      homeToolsCard: 'Åpne praktiske produksjonsreferanser og arbeidsflythjelpere.',
      homeTeamplayBody: 'Filosofien vår er å belønne det å spille sammen. Lokal co-op og multiplayer bør ikke skalere 1:1 vanskeligere bare fordi flere blir med, slik at samarbeid føles oppmuntrende samtidig som solo fortsatt er mulig.',
      homeTeamplayImageAlt: 'Placeholder for spillere som spiller sammen uten bratt vanskelighetshopp',
      homeTeamplayLabel: 'Co-op-filosofi',
      homeTeamplayTitle: 'Teamplay skal føles belønnet.',
      homeUpdatesCard: 'Les de nyeste fremdriftsnotatene fra alle aktive prosjekter.',
      languageSelector: 'Språkvelger',
      linuxCommand: 'Linux-kommando',
      loadingGame: 'Laster spill.',
      loadingGames: 'Laster spill...',
      noGamesFound: 'Ingen spill funnet.',
      noFinishedGamesFound: 'Ingen ferdige spill ennå.',
      noPlannedGamesFound: 'Ingen planlagte spillideer listet ennå.',
      noRoadmapStepsFound: 'Ingen veikartsteg funnet.',
      noRoadmapTextFound: 'Ingen veikarttekst funnet.',
      noUpdatesFound: 'Ingen oppdateringer funnet.',
      noUpcomingGamesFound: 'Ingen kommende spill funnet.',
      finishedGames: 'Ferdige spill',
      moreAboutUsPrompt: 'Mer om oss',
      plannedGameIdeas: 'Spillideer',
      preview: 'Forhåndsvis',
      productionTools: 'Produksjonsverktøy',
      readPost: 'Les innlegg',
      roadmap: 'Veikart',
      sheetBlenderAlt: 'Referanseark for Blender-hurtigtaster',
      sheetBlenderCaption: 'SVG-hurtigtastark for modellering og navigasjon i Blender.',
      sitePages: 'Sider',
      steamDownload: 'Steam-side',
      switchLanguageTo: 'Bytt språk til',
      team: 'Team',
      tools: 'Verktøy',
      toolsInstallLead: 'Linux-brukere kan kopiere kommandoen for verktøyet de trenger. Windows-brukere kan bruke nedlastingslenkene. .NET SDK er med fordi Godot-prosjektene bruker C#.',
      toolsLead: 'Små produksjonshjelpere og referanseark vi bruker når vi lager spill.',
      toolsTitle: 'Produksjonsverktøy.',
      toggleNavigationMenu: 'Åpne eller lukk navigasjonsmeny',
      untitledRoadmapItem: 'Veikartpunkt uten tittel.',
      updates: 'Oppdateringer',
      updatesLead: 'Alle prosjektinnlegg samlet på ett sted, sortert med nyeste oppdatering først.',
      upcomingGames: 'Kommende spill',
      viewGamePage: 'Se spillside',
      visitAseprite: 'Besøk Aseprite',
      visitBlender: 'Besøk Blender',
      visitDotnet: 'Besøk .NET',
      visitGit: 'Besøk Git',
      visitGithub: 'Besøk GitHub',
      visitGithubCli: 'Besøk GitHub CLI',
      visitGodot: 'Besøk Godot',
      visitInkscape: 'Besøk Inkscape',
      visitRoblox: 'Besøk Roblox Creator Hub',
      visitVscode: 'Besøk VS Code',
      workflow: 'Arbeidsflyt',
      workflowAsepriteBody: 'Aseprite brukes til 2D-pixelart, små sprites og pikselfokuserte spilluttrykk når et prosjekt trenger den stilen.',
      workflowBlenderBody: 'Grafikk og lavpoly-assets modelleres i Blender slik at art direction, optimalisering og eksportflyt holder seg lett og praktisk for plattformuavhengige spill.',
      workflowDotnetBody: '.NET SDK støtter C#-delen av Godot-prosjektene våre, inkludert scripting, builds og lokal utviklingsflyt.',
      workflowGitBody: 'Git håndterer lokal versjonskontroll slik at eksperimenter, fikser og feature branches kan spores trygt før de deles.',
      workflowGithubCliBody: 'GitHub CLI gjør repo-arbeid raskt fra terminalen, inkludert innlogging, issues, pull requests og prosjektsjekker.',
      workflowGithubBody: 'All utvikling er versjonskontrollert og offentlig dokumentert gjennom GitHub. Du kan følge oppdateringer, kildekode og fremdriftslogger på tvers av flere prosjekter, fra eksperimentelle systemer til spillbare demoer.',
      workflowGodotBody: 'Fokusert på plattformuavhengig 2D- og 3D-spillutvikling med C#. Godot er nå hovedmotoren vår, valgt for åpen kildekode, fleksibilitet, lav ressursbruk, modulær arbeidsflyt og god Linux-støtte.',
      workflowInkscapeBody: 'Inkscape brukes til ikoner, vektorgrafikk og lett UI-grafikk før assets tas videre inn i spill- eller nettsideflyten.',
      workflowRobloxBody: 'Roblox er en del av innholdsretningen vi kan bygge for, med Roblox Studio til plattformspesifikke opplevelser og eksperimenter.',
      workflowVscodeBody: 'VS Code er hovededitoren for C#, web, scripting, notater og raskt prosjektarbeid på tvers av verktøyflyten.',
      windowsDownload: 'Windows-nedlasting',
    },
  },
};

export const DEFAULT_LANGUAGE = I18N.defaultLanguage;
export const SUPPORTED_LANGUAGES = I18N.languages;

export function normalizeLanguage(language) {
  return SUPPORTED_LANGUAGES.some((entry) => entry.code === language) ? language : DEFAULT_LANGUAGE;
}

export function readInitialLanguage(search = '') {
  const queryLanguage = new URLSearchParams(search).get('lang');

  if (queryLanguage) {
    return normalizeLanguage(queryLanguage);
  }

  try {
    return normalizeLanguage(window.localStorage.getItem(I18N.storageKey));
  } catch (error) {
    return DEFAULT_LANGUAGE;
  }
}

export function writeLanguage(language) {
  try {
    window.localStorage.setItem(I18N.storageKey, normalizeLanguage(language));
  } catch (error) {
    // Storage can be unavailable in private/browser-restricted contexts.
  }
}

export function createTranslator(language) {
  const selectedLanguage = normalizeLanguage(language);
  const selectedTranslations = I18N.strings[selectedLanguage] || I18N.strings[DEFAULT_LANGUAGE];

  return function translate(key) {
    return selectedTranslations[key] || I18N.strings[DEFAULT_LANGUAGE][key] || key;
  };
}
